// react components
import React, {
    useEffect,
    useState,
} from 'react'
import {
    useDispatch,
    useSelector,
} from 'react-redux'

// components
import {
    LinkHelperSite,
} from 'components'

// data
import {
    defaultReduxState,
    reduxModalErrorEventHandlerSite,
    reduxSalesAddToCartSite,
} from 'data'

// pages
import {
    CheckboxInput816Site,
    DateTimeInput816Site,
    EditBlockSite,
    LocationInput816Site,
    PhoneNumberInput816Site,
    SelectInput816Site,
    TextAreaInput816Site,
    TextInput816Site,
} from 'pages'

// serializers
import {
    CustomCSSProperties,
    MainStyleSerializer,
    PortfolioPageContentListSiteSerializer,
    Template802SiteSerializer,
} from 'serializers/site'

// services
import {
    getTextSite,
    getStylesNew,
    validateEmailSite,
} from 'services'

// props
type TemplateBlock802SiteProps = {
    blockId: string
    content: Template802SiteSerializer | undefined
    isEditHovered: boolean
    mainParentId?: number
    object: PortfolioPageContentListSiteSerializer
    parentArray?: number[]
    parentStyles?: any
    styles: any
    stylesEdit: MainStyleSerializer | undefined
}

// main
export const TemplateBlock802Site: React.FC<TemplateBlock802SiteProps> = React.memo(({
    blockId,
    content,
    isEditHovered,
    mainParentId,
    object,
    parentArray,
    parentStyles,
    styles,
    stylesEdit,
}) => {

    const dispatch = useDispatch()
    const reduxCacheSite = useSelector((state: defaultReduxState) => state.reduxCacheSite)
    const reduxModalSite = useSelector((state: defaultReduxState) => state.reduxModalSite)
    const reduxSalesSite = useSelector((state: defaultReduxState) => state.reduxSalesSite)
    const reduxText = useSelector((state: defaultReduxState) => state.reduxText.data)

    const deviceType = reduxModalSite.deviceType

    useEffect(() => {
        console.log('content', content)
        setQty(1)
        setVariant(content?.variants?.[0]?.id)
        setVariantObject(content?.variants?.[0])
    }, [
        content?.id,
    ])


    const [qty, setQty] = useState<number>(1)
    const [stockMaxValue, setStockMaxValue] = useState<number>()
    const [variant, setVariant] = useState<any>(content?.variants?.[0]?.id)
    const [variantObject, setVariantObject] = useState<any>(content?.variants?.[0])
    const [formData, setFormData] = useState<{ [key: string]: any }>({})
    const [errorData, setErrorData] = useState<{ [key: string]: string }>({})
    const [packageOptions, setPackageOptions] = useState<{ [key: number]: { [key: number]: number } }>({})

    const [stylesNew, setStylesNew] = useState<{
        buttonStyle: CustomCSSProperties | undefined,
        hasHoverStyle: boolean,
        hoverStyleBackground: string | undefined,
        hoverStyleBorderColor: string | undefined,
        hoverStyleColor: string | undefined,
        qytInputStyle: CustomCSSProperties | undefined,
        qytInputIconStyle: CustomCSSProperties | undefined,
        qytInputWrapStyle: CustomCSSProperties | undefined,
        showQty: 'true' | 'false' | undefined,
        variantStyle: CustomCSSProperties | undefined,
        // @ts-ignore
    }>(applyStyles())
    const [newStyles, setNewStyles] = useState<any>(stylesNew?.buttonStyle)

    useEffect(() => {
        const tempStyles = applyStyles()
        // @ts-ignore
        setStylesNew(tempStyles)
        setNewStyles(applyStyles()?.buttonStyle)
    }, [
        object.id,
        reduxModalSite,
        styles,
        stylesEdit,
    ])

    function applyStyles() {
        try {
            const buttonStyle = getStylesNew(reduxModalSite, styles, stylesEdit)
            const hoverStyleBackground = buttonStyle?.hoverBackground
            const hoverStyleBorderColor = buttonStyle?.hoverBorderColor
            const hoverStyleColor = buttonStyle?.hoverColor
            const hasHoverStyle = Boolean(hoverStyleBackground || hoverStyleBorderColor || hoverStyleColor)
            return {
                buttonStyle: buttonStyle,
                hoverStyleBackground: hoverStyleBackground,
                hoverStyleBorderColor: hoverStyleBorderColor,
                hoverStyleColor: hoverStyleColor,
                hasHoverStyle: hasHoverStyle,
                qytInputStyle: {
                    background: buttonStyle?.qtyInputBackground,
                    borderColor: buttonStyle?.qtyInputBorderColor,
                    borderRadius: buttonStyle?.qtyInputBorderRadius,
                    borderStyle: buttonStyle?.qtyInputBorderStyle,
                    borderWidth: buttonStyle?.qtyInputBorderWidth,
                    color: buttonStyle?.qtyInputColor,
                    fontFamily: buttonStyle?.qtyInputFontFamily,
                    fontSize: buttonStyle?.qtyInputFontSize,
                    padding: buttonStyle?.qtyInputPadding,
                    textAlign: buttonStyle?.qtyInputTextAlign,
                    width: buttonStyle?.qtyInputWidth,
                },
                qytInputIconStyle: {
                    background: buttonStyle?.qtyInputBackground,
                },
                qytInputWrapStyle: {
                    margin: buttonStyle?.qtyInputMargin,
                },
                showQty: buttonStyle?.qtyInputShow,
                variantStyle: {
                    background: buttonStyle?.variantBackground,
                    borderColor: buttonStyle?.variantBorderColor,
                    borderRadius: buttonStyle?.variantBorderRadius,
                    borderStyle: buttonStyle?.variantBorderStyle,
                    borderWidth: buttonStyle?.variantBorderWidth,
                    color: buttonStyle?.variantColor,
                    fontFamily: buttonStyle?.variantFontFamily,
                    fontSize: buttonStyle?.variantFontSize,
                    margin: buttonStyle?.variantMargin,
                    padding: buttonStyle?.variantPadding,
                    width: buttonStyle?.variantWidth,
                },
            }
        } catch (error) {
            dispatch(reduxModalErrorEventHandlerSite(
                error,
                'TemplateBlock802Site',
                'applyStyles',
            ))
        }
    }

    useEffect(() => {
        if (variantObject) {
            if (!variantObject.is_qty_available) {
                setQty(1)
                setStockMaxValue(1)
            } else if (variantObject.has_stock_management) {
                if (qty > variantObject.stock) {
                    setQty(variantObject.stock)
                }
                setStockMaxValue(variantObject.stock)
            } else {
                setStockMaxValue(undefined)
            }
        } else if (content?.has_stock_management) {
            if (qty > (content?.stock || 0)) {
                setQty(content?.stock || 0)
            }
            setStockMaxValue(content?.stock)
        } else {
            setStockMaxValue(undefined)
        }
    }, [
        variantObject,
    ])

    function handleInputChange(e: any) {
        try {
            setFormData(prev => ({
                ...prev,
                [e.name]: e.value,
            }))

            // Clear error for this field when user starts typing
            if (errorData[e.name]) {
                setErrorData(prev => {
                    const newErrors = { ...prev }
                    delete newErrors[e.name]
                    return newErrors
                })
            }
        } catch (error) {
            dispatch(reduxModalErrorEventHandlerSite(
                error,
                'TemplateBlock802Site',
                'handleInputChange',
            ))
        }
    }

    function resetForm() {
        try {
            if (content?.form_fields?.length) {
                const resetFormData: { [key: string]: any } = {}
                content.form_fields.forEach(field => {
                    if (field.field_type === 'checkbox') {
                        resetFormData[field.name!] = false
                    } else {
                        resetFormData[field.name!] = ''
                    }
                })
                setFormData(resetFormData)
                setErrorData({})
            }

            // Reset proposed price for free pricing products
            if (content?.is_free_pricing) {
                setFormData(prev => ({
                    ...prev,
                    proposed_price: ''
                }))
            }

            // Reset package options
            setPackageOptions({})
        } catch (error) {
            dispatch(reduxModalErrorEventHandlerSite(
                error,
                'TemplateBlock802Site',
                'resetForm',
            ))
        }
    }

    function handlePackageOptionItemChange(optionId: number, itemId: number, qty: number) {
        try {
            setPackageOptions(prev => {
                const newPackageOptions = {
                    ...prev,
                    [optionId]: {
                        ...prev[optionId],
                        [itemId]: qty
                    }
                }

                // If this is a free option being unchecked, check if all free options are now unchecked
                const freeOption = content?.package_options?.find(opt => opt.name === 'Options gratuites')
                if (freeOption && content?.package_options?.some(opt => opt.name === 'Options gratuites')) {
                    const allFreeOptionsUnchecked = freeOption.items?.every(item =>
                        !newPackageOptions[freeOption.id!]?.[item.id!] || newPackageOptions[freeOption.id!]?.[item.id!] === 0
                    )

                    // If all free options are unchecked, reset paid options quantities
                    if (allFreeOptionsUnchecked) {
                        const paidOption = content?.package_options?.find(opt => opt.name === 'Options payantes')
                        if (paidOption && paidOption.items) {
                            paidOption.items.forEach(item => {
                                if (newPackageOptions[paidOption.id!]) {
                                    newPackageOptions[paidOption.id!][item.id!] = 0
                                }
                            })
                        }
                    }
                }

                return newPackageOptions
            })
        } catch (error) {
            dispatch(reduxModalErrorEventHandlerSite(
                error,
                'TemplateBlock802Site',
                'resetForm',
            ))
        }
    }

    function onAddToCart() {
        try {
            // For free pricing, quantity is always 1, so skip the qty check
            if (!content?.is_free_pricing && qty < 1) return

            // Check if all required form fields are filled
            if (content?.form_fields?.length) {
                const errors: { [key: string]: string } = {}
                let hasErrors = false

                for (const field of content.form_fields) {
                    const value = formData[field.name!]

                    // Helper function to get the actual value string
                    const getValueString = (val: any): string => {
                        if (typeof val === 'string') return val
                        if (val && typeof val === 'object' && val.value) return val.value
                        if (val && typeof val === 'object' && val.id) return val.id
                        return String(val || '')
                    }

                    const valueString = getValueString(value)

                    // Check required fields
                    if (field.required) {
                        if (field.field_type === 'checkbox') {
                            if (!value) {
                                errors[field.name!] = reduxText[7489]
                                hasErrors = true
                            }
                        } else {
                            if (!valueString || valueString.trim() === '') {
                                errors[field.name!] = reduxText[7489]
                                hasErrors = true
                            }
                        }
                    }

                    // Check email validation for all email fields with values (required or not)
                    if (field.field_type === 'email' && valueString && valueString.trim() !== '') {
                        if (!validateEmailSite(valueString)) {
                            errors[field.name!] = reduxText[7490]
                            hasErrors = true
                        }
                    }
                }

                if (hasErrors) {
                    setErrorData(errors)
                    return
                }

                // Clear errors if validation passes
                setErrorData({})
            }

            // Check if proposed price is required for free pricing
            if (content?.is_free_pricing) {
                const proposedPriceValue = formData['proposed_price']
                if (!proposedPriceValue || String(proposedPriceValue).trim() === '') {
                    setErrorData({ 'proposed_price': reduxText[10338] })
                    return
                }

                // Validate that the proposed price is a valid positive number
                const proposedPriceNumber = Number(proposedPriceValue)
                if (isNaN(proposedPriceNumber) || proposedPriceNumber <= 0) {
                    setErrorData({ 'proposed_price': reduxText[10339] })
                    return
                }

                // Clear errors if validation passes
                setErrorData({})
            }

            if (reduxCacheSite.portfolio) {
                // Prepare extra data from form fields with labels
                let extraDataJson: { [key: string]: any } | undefined = undefined
                if (content?.form_fields?.length) {
                    extraDataJson = {
                        form: {}
                    }

                    // Add regular form fields
                    content.form_fields.forEach(field => {
                        if (formData[field.name!] !== undefined && formData[field.name!] !== '') {
                            extraDataJson!.form[field.name!] = {
                                label: field.label || field.name || 'Unknown Field',
                                value: formData[field.name!]
                            }
                        }
                    })
                }

                // Prepare package options data - send selected items with all necessary information
                const packageOptionsData = content?.package_options?.flatMap(option =>
                    option.items?.filter(item =>
                        (packageOptions[option.id!]?.[item.id!] || 0) > 0
                    ).map(item => ({
                        id: item.id,
                        package_option: {
                            id: option.id,
                            name: option.name
                        },
                        product: {
                            id: item.product?.id,
                            name: item.product?.name,
                            unit_price: item.product?.unit_price || 0
                        },
                        qty: packageOptions[option.id!]?.[item.id!] || 0
                    })) || []
                ).filter(item => item.qty > 0)

                dispatch(reduxSalesAddToCartSite(
                    content?.is_free_pricing ? 1 : qty,
                    content?.is_free_pricing ? Number(formData['proposed_price']) : (variantObject?.unit_price || content?.unit_price),
                    content,
                    variantObject,
                    content?.absolute_site_url,
                    reduxCacheSite.portfolio,
                    packageOptionsData,
                    reduxModalSite.currencyId,
                    extraDataJson
                ))

                // Reset form after successful addition to cart
                if (content?.form_fields?.length || content?.is_free_pricing) {
                    resetForm()
                }
            }
        } catch (error) {
            dispatch(reduxModalErrorEventHandlerSite(
                error,
                'TemplateBlock802Site',
                'onAddToCart',
            ))
        }
    }

    function onHover(direction: string) {
        try {
            if (stylesNew?.hasHoverStyle) {
                if (direction === 'over') {
                    if (stylesNew.buttonStyle) {
                        const newnewStyle = Object.assign({}, stylesNew.buttonStyle)
                        if (stylesNew.hoverStyleBackground) newnewStyle.background = stylesNew.hoverStyleBackground
                        if (stylesNew.hoverStyleBorderColor) newnewStyle.borderColor = stylesNew.hoverStyleBorderColor
                        if (stylesNew.hoverStyleColor) newnewStyle.color = stylesNew.hoverStyleColor
                        setNewStyles(newnewStyle)
                    } else {
                        setNewStyles(undefined)
                    }
                } else {
                    if (stylesNew.buttonStyle) {
                        setNewStyles(stylesNew.buttonStyle)
                    } else {
                        setNewStyles(undefined)
                    }
                }
            }
        } catch (error) {
            dispatch(reduxModalErrorEventHandlerSite(
                error,
                'TemplateBlock802Site',
                'onHover',
            ))
        }
    }

    let variantStockOk = true
    if (content?.variants?.[0] && content.variants[0].stock_status?.id !== 1) {
        variantStockOk = false
    }
    let uniqueProductInCart = false
    // For products with form fields or free pricing, allow multiple additions
    // For unique products without forms and not free pricing, check if already in cart
    if (content?.is_unique && !content?.form_fields?.length && !content?.is_free_pricing && reduxSalesSite.salesLines.find((line) => line.product.id === content?.id)) {
        uniqueProductInCart = true
    }

    return (
        <div
            id={blockId}
            className={`template-block-802${isEditHovered ? ' is-edit-hovered' : ''} ${deviceType}`}
        >
            {/* Package Options Selection */}
            {content?.package_options && content.package_options.length > 0 && (
                <div className='t-802-package-options-wrap'>
                    {content.package_options.map(option => {
                        // Hide "Options payantes" unless at least one "Options gratuites" item is checked
                        if (option.name === 'Options payantes') {
                            const hasFreeOptionsChecked = content.package_options?.some(freeOption =>
                                freeOption.name === 'Options gratuites' &&
                                freeOption.items?.some(item =>
                                    packageOptions[freeOption.id!]?.[item.id!] > 0
                                )
                            )

                            if (!hasFreeOptionsChecked) {
                                return null
                            }
                        }

                        return (
                            <div key={option.id} className='t-802-package-option'>
                                <div className='t-802-package-option-info'>
                                    <span className='t-802-package-option-name'>{option.name}</span>
                                    {option.items && option.items.length > 0 && (
                                        <div className='t-802-package-option-items'>
                                            {option.items.map(item => (
                                                <div key={item.id} className='t-802-package-option-item'>
                                                    <div className='t-802-package-option-item-info'>
                                                        <span className='t-802-package-option-item-name'>
                                                            {item.product?.name}
                                                            {item.product?.unit_price && (
                                                                <span className='t-802-package-option-item-price'>
                                                                    ({item.product?.unit_price} {reduxCacheSite.portfolio?.currency?.symbol || reduxCacheSite.portfolio?.currency?.iso_code}{item.product?.is_recurring ? '/mois' : ''})
                                                                </span>
                                                            )}
                                                        </span>
                                                    </div>
                                                    {option.name === 'Options gratuites' ? (
                                                        <div className='t-802-package-option-item-checkbox'>
                                                            <input
                                                                checked={Boolean(packageOptions[option.id!]?.[item.id!])}
                                                                className='t-802-package-option-item-checkbox-input'
                                                                onChange={(e) => handlePackageOptionItemChange(option.id!, item.id!, e.target.checked ? 1 : 0)}
                                                                type='checkbox'
                                                            />
                                                        </div>
                                                    ) : (
                                                        <div className='t-802-package-option-item-qty'>
                                                            <button
                                                                className='t-802-package-option-item-qty-btn minus'
                                                                onClick={() => handlePackageOptionItemChange(option.id!, item.id!, Math.max(0, (packageOptions[option.id!]?.[item.id!] || 0) - 1))}
                                                                type='button'
                                                            >
                                                                -
                                                            </button>
                                                            <span className='t-802-package-option-item-qty-value'>
                                                                {packageOptions[option.id!]?.[item.id!] || 0}
                                                            </span>
                                                            <button
                                                                className='t-802-package-option-item-qty-btn plus'
                                                                onClick={() => handlePackageOptionItemChange(option.id!, item.id!, (packageOptions[option.id!]?.[item.id!] || 0) + 1)}
                                                                type='button'
                                                            >
                                                                +
                                                            </button>
                                                        </div>
                                                    )}
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </div>
                        )
                    })}
                </div>
            )}

            {/* Price Proposal Field for Free Pricing */}
            {content?.is_free_pricing && (
                <div className='t-802-price-proposal-wrap'>
                    <div className='t-802-price-proposal-field'>
                        <div className={`input-816 text-input-816 ${deviceType}`}>
                            <span className={`input-816-label ${deviceType}`}>
                                {reduxText[10340]} ({reduxCacheSite.portfolio?.currency?.symbol || reduxCacheSite.portfolio?.currency?.iso_code})
                            </span>
                            <input
                                className={`ti-802-price-input ${deviceType}`}
                                name="proposed_price"
                                onChange={(e) => handleInputChange({ name: 'proposed_price', value: e.target.value })}
                                placeholder="0.00"
                                step="0.01"
                                min="0.01"
                                type="number"
                                value={formData['proposed_price'] || ''}
                            />
                        </div>
                        {errorData['proposed_price'] && (
                            <div className="t-802-field-error">{errorData['proposed_price']}</div>
                        )}
                    </div>
                </div>
            )}

            {(content?.form_fields?.length! > 0) && (
                <div className='t-802-form-fields-wrap'>
                    {content?.form_fields?.map(val => {
                        if (val.field_type === 'separator') {
                            return (
                                <div key={val.id}>
                                    <div className="t-802-field-separator">{val.label}</div>
                                </div>
                            )
                        }
                        if (val.field_type === 'email') {
                            return (
                                <div key={val.id}>
                                    <TextInput816Site
                                        error={undefined}
                                        label={val.label!}
                                        name={val.name!}
                                        onChange={handleInputChange}
                                        value={formData[val.name!] || ''}
                                    />
                                    {errorData[val.name!] && (
                                        <div className="t-802-field-error">{errorData[val.name!]}</div>
                                    )}
                                </div>
                            )
                        }
                        if (val.field_type === 'text') {
                            return (
                                <div key={val.id}>
                                    <TextInput816Site
                                        error={undefined}
                                        label={val.label!}
                                        name={val.name!}
                                        onChange={handleInputChange}
                                        value={formData[val.name!] || ''}
                                    />
                                    {errorData[val.name!] && (
                                        <div className="t-802-field-error">{errorData[val.name!]}</div>
                                    )}
                                </div>
                            )
                        }
                        if (val.field_type === 'textarea') {
                            return (
                                <div key={val.id}>
                                    <TextAreaInput816Site
                                        error={undefined}
                                        label={val.label!}
                                        name={val.name!}
                                        onChange={handleInputChange}
                                        value={formData[val.name!] || ''}
                                    />
                                    {errorData[val.name!] && (
                                        <div className="t-802-field-error">{errorData[val.name!]}</div>
                                    )}
                                </div>
                            )
                        }
                        if (val.field_type === 'checkbox') {
                            return (
                                <div key={val.id}>
                                    <CheckboxInput816Site
                                        error={undefined}
                                        label={val.label!}
                                        name={val.name!}
                                        onChange={handleInputChange}
                                        value={formData[val.name!] || false}
                                    />
                                    {errorData[val.name!] && (
                                        <div className="t-802-field-error">{errorData[val.name!]}</div>
                                    )}
                                </div>
                            )
                        }
                        if (val.field_type === 'date') {
                            return (
                                <div key={val.id}>
                                    <DateTimeInput816Site
                                        error={undefined}
                                        format='date'
                                        label={val.label!}
                                        name={val.name!}
                                        onChange={handleInputChange}
                                        value={formData[val.name!] || ''}
                                    />
                                    {errorData[val.name!] && (
                                        <div className="t-802-field-error">{errorData[val.name!]}</div>
                                    )}
                                </div>
                            )
                        }
                        if (val.field_type === 'datetime') {
                            return (
                                <div key={val.id}>
                                    <DateTimeInput816Site
                                        error={undefined}
                                        format='date'
                                        label={val.label!}
                                        name={val.name!}
                                        onChange={handleInputChange}
                                        value={formData[val.name!] || ''}
                                    />
                                    {errorData[val.name!] && (
                                        <div className="t-802-field-error">{errorData[val.name!]}</div>
                                    )}
                                </div>
                            )
                        }
                        if (val.field_type === 'location') {
                            return (
                                <div key={val.id}>
                                    <LocationInput816Site
                                        error={undefined}
                                        label={val.label!}
                                        name={val.name!}
                                        onChange={handleInputChange}
                                        value={formData[val.name!] || ''}
                                    />
                                    {errorData[val.name!] && (
                                        <div className="t-802-field-error">{errorData[val.name!]}</div>
                                    )}
                                </div>
                            )
                        }
                        if (val.field_type === 'phonenumber') {
                            return (
                                <div key={val.id}>
                                    <PhoneNumberInput816Site
                                        error={undefined}
                                        label={val.label!}
                                        name={val.name!}
                                        onChange={handleInputChange}
                                        value={formData[val.name!] || ''}
                                    />
                                    {errorData[val.name!] && (
                                        <div className="t-802-field-error">{errorData[val.name!]}</div>
                                    )}
                                </div>
                            )
                        }
                        if (val.field_type === 'select2') {
                            return (
                                <div key={val.id}>
                                    <SelectInput816Site
                                        error={undefined}
                                        label={val.label!}
                                        name={val.name!}
                                        onChange={handleInputChange}
                                        options={val.options || []}
                                        value={formData[val.name!] || ''}
                                    />
                                    {errorData[val.name!] && (
                                        <div className="t-802-field-error">{errorData[val.name!]}</div>
                                    )}
                                </div>
                            )
                        }
                        if (val.field_type === 'selectmultiple') {
                            return (
                                <div key={val.id}>
                                    <SelectInput816Site
                                        error={undefined}
                                        label={val.label!}
                                        multi
                                        name={val.name!}
                                        onChange={handleInputChange}
                                        options={val.options || []}
                                        value={formData[val.name!] || ''}
                                    />
                                    {errorData[val.name!] && (
                                        <div className="t-802-field-error">{errorData[val.name!]}</div>
                                    )}
                                </div>
                            )
                        }
                    })}
                </div>
            )}
            <div>
                {content?.price_on_request && (
                    <LinkHelperSite
                        action={undefined}
                        className={`t-802-button extra-button ${deviceType}`}
                        onClick={() => undefined}
                        style={newStyles}
                        to={undefined}
                    >
                        {reduxText[8528]}
                    </LinkHelperSite>
                )}
                {content?.has_sales_permission && content?.variants && content?.variants.length > 0 && (
                    <select
                        className={`t-802-variants ${deviceType}`}
                        name='variant'
                        onChange={(e) => {
                            setVariant(e.target.value)
                            setVariantObject(content?.variants?.[content?.variants.findIndex((object) => object.id === Number(e.target.value))])
                        }}
                        style={stylesNew.variantStyle}
                        value={variant}
                    >
                        {content?.variants.map((val) => (
                            <option
                                key={val.id}
                                disabled={val.stock_status?.id !== 1}
                                value={val.id}
                            >
                                {val.name}{' '}
                                ({val.price_on_request
                                    ? (
                                        reduxText[7494]
                                    ) : (
                                        `${val.unit_price} ${reduxCacheSite.portfolio?.currency?.symbol || reduxCacheSite.portfolio?.currency?.iso_code}${val.stock_status?.id !== 1 ? ` - ${val.stock_status?.name}` : ''}`
                                    )})
                            </option>
                        ))}
                    </select>
                )}
                {!content?.price_on_request && (variantStockOk && content?.stock_status?.id === 1) && content?.has_sales_permission && (
                    <div className={`t-802-actions ${deviceType}`}>
                        {/* Hide quantity controls when there are form fields or free pricing */}
                        {(stylesNew.showQty !== 'false' && content?.is_qty_available && !content?.form_fields?.length && !content?.is_free_pricing) && (
                            <div
                                className={`t-802-actions-wrap ${deviceType}`}
                                style={stylesNew.qytInputWrapStyle}
                            >
                                <div className={`t-802-actions-qty minus ${deviceType}`} >
                                    <i
                                        className={`t-802-actions-icon mo-new-icon-minus-solid ${deviceType}`}
                                        onClick={() => setQty(qty > 1 ? qty - 1 : 1)}
                                        style={stylesNew.qytInputIconStyle}
                                    />
                                </div>
                                <input
                                    max={stockMaxValue}
                                    min={0}
                                    name='qty'
                                    onChange={(e) => setQty(Number(e.target.value))}
                                    style={stylesNew.qytInputStyle}
                                    type='number'
                                    value={qty.toString() || ''}
                                />
                                <div className={`t-802-actions-qty plus ${deviceType}`}>
                                    <i
                                        className={`t-802-actions-icon mo-new-icon-plus-solid ${deviceType}`}
                                        onClick={() => setQty(stockMaxValue ? (qty < stockMaxValue ? qty + 1 : stockMaxValue) : qty + 1)}
                                        style={stylesNew.qytInputIconStyle}
                                    />
                                </div>
                            </div>
                        )}
                        <LinkHelperSite
                            action={undefined}
                            className={`t-802-button ${deviceType}`}
                            disabled={uniqueProductInCart || qty < 1}
                            onClick={() => onAddToCart()}
                            onCustomMouseLeave={() => onHover('leave')}
                            onCustomMouseOver={() => onHover('over')}
                            style={newStyles}
                            to={undefined}
                        >
                            {uniqueProductInCart ? reduxText[9675] : (!content?.text ? reduxText[8612] : getTextSite(content?.text, reduxModalSite, reduxText))}
                        </LinkHelperSite>
                    </div>
                )}
                {!content?.has_sales_permission && content?.external_link && (
                    <LinkHelperSite
                        action='href'
                        className={`t-802-button extra-button ${deviceType}`}
                        onClick={() => undefined}
                        onCustomMouseLeave={() => onHover('leave')}
                        onCustomMouseOver={() => onHover('over')}
                        style={newStyles}
                        to={content?.external_link}
                    >
                        {content?.text2 || content?.external_link}
                    </LinkHelperSite>
                )}
                {content?.stock_status && content.stock_status.id !== 1 && (
                    <LinkHelperSite
                        action={undefined}
                        className={`t-802-button extra-button ${deviceType}`}
                        onClick={() => undefined}
                        onCustomMouseLeave={() => onHover('leave')}
                        onCustomMouseOver={() => onHover('over')}
                        style={newStyles}
                        to={undefined}
                    >
                        {content.stock_status.name}
                    </LinkHelperSite>
                )}
            </div>
            <EditBlockSite
                mainParentId={mainParentId || object.id!}
                object={object}
                parentArray={parentArray}
                parentStyles={parentStyles}
            />
        </div>
    )
})
